import React, { useRef, useEffect, useState } from 'react';
import { useContent } from '../cms/content.js';

export default function Interlude() {
  const cms = useContent();
  const sectionRef = useRef(null);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const section = sectionRef.current;
    if (!section) return;

    let raf;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        const rect = section.getBoundingClientRect();
        const vh = window.innerHeight;
        // Normalize so 0 = section center aligns with viewport center.
        const normalized = (rect.top + rect.height / 2 - vh / 2) / vh;
        // Shift text 60px across the viewport traversal for a gentle parallax.
        setOffset(normalized * 60);
        raf = null;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      id="interlude"
      style={{
        position: 'relative',
        zIndex: 11,
        padding: '80px 24px',
        textAlign: 'center',
        background: 'linear-gradient(180deg, transparent, rgba(10,10,11,0.4) 20%, rgba(10,10,11,0.4) 80%, transparent)',
        borderTop: '1px solid rgba(201,168,106,0.1)',
        borderBottom: '1px solid rgba(201,168,106,0.1)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '320px',
      }}
    >
      <div
        data-reveal=""
        style={{
          maxWidth: '960px',
          margin: '0 auto',
          transform: `translateY(${offset}px)`,
          willChange: 'transform',
        }}
      >
        <p
          style={{
            fontFamily: "'Cormorant',serif",
            fontWeight: 400,
            fontStyle: 'italic',
            fontSize: 'clamp(24px, 3vw, 42px)',
            lineHeight: 1.3,
            color: '#e8e2d4',
            textTransform: 'none',
            margin: 0,
            opacity: 0.85,
          }}
        >
          {cms.interlude.quote}
        </p>
      </div>
    </section>
  );
}
